"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = median;

function median(values) {
  if (values.length === 0) return 0;
  var index = Math.floor(values.length / 2);
  values.sort(function (a, b) {
    return a - b;
  });
  return values.length % 2 ? values[index] : Math.round((values[index - 1] + values[index]) / 2);
}